import { Route, createRoutesFromElements, redirect } from 'react-router-dom';
import { AccountLayout } from 'layouts';
import { RequireAuth } from 'components';
import {
  OverviewContainer,
  Subscription,
  YoutubeChannel,
} from 'pages/Account/pages';
import { locations } from './locations';

const accountRoutes = createRoutesFromElements(
  <Route
    id="account"
    path={locations.account.main.pathname}
    element={
      <RequireAuth>
        <AccountLayout />
      </RequireAuth>
    }
  >
    <Route
      id="account-index"
      index
      loader={() => redirect(locations.account.overview.pathname)}
    />
    <Route
      id="account-overview"
      path={locations.account.overview.pathname}
      element={<OverviewContainer />}
    />
    <Route
      id="account-subscription"
      path={locations.account.subscription.pathname}
      element={<Subscription />}
    />
    <Route
      id="account-youtube"
      path={locations.account.youTube.pathname}
      element={<YoutubeChannel />}
    />
  </Route>
);
export default accountRoutes;
